module.exports = __webpack_public_path__ + "images/d0e8eae93324694b7bbee65d66717235-ERM_Logo_2C_RGB_nav.png";